import NavigationMinimal from "../components/layout/NavigationMinimal";
import React from 'react'
import RegistrationSkeleton from "../components/challenger/RegistrationSkeleton";

const Challenger = () => {
    return (
        <>
            <NavigationMinimal/>
            <div className="sub-hero">
                <span className="sub-hero__eyebrow">Mitmachen</span>
                <h1 className="sub-hero__title">Mini-Challenger</h1>
                <p className="sub-hero__lead">Melde dich jetzt für das nächste Turnier an und tritt gegen andere Spieler an.</p>
            </div>
            <main className="page-shell page-shell--after-hero">
                <div id="challenger">
                    <RegistrationSkeleton />
                </div>
            </main>
        </>
    );
}

export default Challenger;
